function initState() {
    return {
        listingDetail: null,
        payment: null,
        pricePerMonth: 0,
        agentInfo: null,
        showMakeOffer: false,
        prevAndNext: {
            prevHref: '',
            canPrev: false,
            nextHref: '',
            canNext: false,
            show: false
        },
        tourBtnList: [],
        shares: {
            facebookHref: '',
            twitterHref: '',
            linkedinHref: '',
            gmailHref: ''
        },
        coAgent: null,
        daysOnSite: 0,
        triggerReadMore: false,
        openReadMore: false,
        hasFavor: false,
        scheduleTitle: '',
        scheduleButtonText: '',
        scheduleTourButtonText: '',
        scheduleATourButtonText: '',
        showVirtualTour: true,
        makeOfferButtonText: '',
        makeOfferTitle: '',
        scheduleNameFormat: '',
        schedulePhoneRequired: false,
        soldFormTitle: '',
        soldFormButtonText: '',
        soldFormNameFormat: '',
        soldFormPhoneRequired: false,
        infoFlag: {
            flag: '',
            text: '',
            show: false,
            className: ''
        },
        scheduleComponentStatus: {
            selectedDateIndex: -1,
            datePage: 0,
            tourTypeIdx: 0,
            success: false,
            appointTime: '',
            offer: {
                price: '',
                message: ''
            }
        },
        company: {
            name: ''
        }
    };
}

export default {
    namespaced: true,
    state: initState,
    getters: {},
    mutations: {
        updateScheduleComponentStatus_selectedDateIndex(state, idx) {
            state.scheduleComponentStatus.selectedDateIndex = idx;
        },
        updateScheduleComponentStatus_datePage(state, idx) {
            state.scheduleComponentStatus.datePage = idx;
        },
        updateScheduleComponentStatus_tourTypeIdx(state, idx) {
            state.scheduleComponentStatus.tourTypeIdx = idx;
        },
        updateScheduleComponentStatus_appointment(state, payload) {
            if ('success' in payload) {
                state.scheduleComponentStatus.success = payload.success;
            }
            if ('appointTime' in payload) {
                state.scheduleComponentStatus.appointTime = payload.appointTime;
            }
            if ('offer' in payload) {
                Object.assign(
                    state.scheduleComponentStatus.offer,
                    payload.offer
                );
            }
        },
        updateCompanyInfo(state, { name }) {
            state.company.name = name;
        },
        updateListingDetail(state, detail) {
            state.listingDetail = detail;
        },
        updatePayment(state, payment) {
            state.payment = payment;
        },
        updatePerMonth(state, pricePerMonth) {
            state.pricePerMonth = pricePerMonth;
        },
        updateAgentInfo(state, agentInfo) {
            state.agentInfo = agentInfo;
        },
        updateShowMakeOffer(state, showMakeOffer) {
            state.showMakeOffer = showMakeOffer;
        },
        updatePrevAndNext(state, prevAndNext) {
            state.prevAndNext = prevAndNext;
        },
        updateTourBtn(state, list) {
            state.tourBtnList = list;
        },
        updateShare(state, shares) {
            state.shares = shares;
        },
        updateCoAgent(state, agent) {
            state.coAgent = agent;
        },
        updateDaysOnSite(state, daysOnSite) {
            state.daysOnSite = daysOnSite;
        },
        upTriggerReadMore(state, triggerReadMore) {
            state.triggerReadMore = triggerReadMore;
        },
        updateOpenReadMore(state, openReadMore) {
            state.openReadMore = openReadMore;
        },
        toggleOpenReadMore(state) {
            state.openReadMore = !state.openReadMore;
        },
        updateHasFavor(state, hasFavor) {
            state.hasFavor = hasFavor;
        },
        toggleHasFavor(state) {
            state.hasFavor = !state.hasFavor;
        },
        updateScheduleTitle(state, scheduleTitle) {
            state.scheduleTitle = scheduleTitle;
        },
        // updateScheduleButtonText(state, scheduleButtonText) {
        //     state.scheduleButtonText = scheduleButtonText;
        // },
        updateScheduleATourButtonText(state, scheduleATourButtonText) {
            state.scheduleATourButtonText = scheduleATourButtonText;
        },
        updateShowVirtualTour(state, newVal) {
            state.showVirtualTour = newVal;
        },
        updateMakeOfferButtonText(state, makeOfferButtonText) {
            state.makeOfferButtonText = makeOfferButtonText;
        },
        updateMakeOfferTitle(state, makeOfferTitle) {
            state.makeOfferTitle = makeOfferTitle;
        },
        updateScheduleNameFormat(state, scheduleNameFormat) {
            state.scheduleNameFormat = scheduleNameFormat;
        },
        updateSchedulePhoneRequired(state, schedulePhoneRequired) {
            state.schedulePhoneRequired = schedulePhoneRequired;
        },
        updateSoldFormTitle(state, soldFormTitle) {
            state.soldFormTitle = soldFormTitle;
        },
        updateSoldFormButtonText(state, soldFormButtonText) {
            state.soldFormButtonText = soldFormButtonText;
        },
        updateSoldFormNameFormat(state, soldFormNameFormat) {
            state.soldFormNameFormat = soldFormNameFormat;
        },
        updateSoldFormPhoneRequired(state, soldFormPhoneRequired) {
            state.soldFormPhoneRequired = soldFormPhoneRequired;
        },
        updateInfoFlag(state, infoFlag) {
            state.infoFlag = infoFlag;
        }
    }
};
